import React, { FunctionComponent } from 'react';

import { Route } from 'react-router-dom';

import { CallPage } from '../../../../../../pages/call';
import type { ErrorPageType } from '../../../../../components/error-page/types';
import { PSNotifications } from '../../../../notifications/ps-notifications';

interface CallsWithSidebarViewProps {
    withChat?: boolean;
    errorPageType: ErrorPageType | null;
}

export const CallsWithSidebarView: FunctionComponent<CallsWithSidebarViewProps> = ({ withChat, errorPageType }) => {
    if (errorPageType) {
        return null;
    }

    return (
        <Route path="/j/:id">
            <CallPage isChatAllowed={withChat} />
            <PSNotifications />
        </Route>
    );
};
